export default __webpack_public_path__ + "static/eufunds-d2d21693fb9be22490ba671ed7119d40.svg";